import { useHistory, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import InstallationSubpageLayout from "./installation/InstallationSubpageLayout";
import InstallationVisualizationPanel from "./installation/InstallationVisualizationPanel";
import { useInstallationCamera } from "./installation/useInstallationCamera";

const AppInstallationVisualization = ({ setCookies, saveUser }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { id } = useParams();
  const { loading, cycleEntries } = useInstallationCamera(id);

  return (
    <InstallationSubpageLayout
      pageTitle={t("installation_visualization_raw_title")}
      onBack={() => history.goBack()}
      setCookies={setCookies}
      saveUser={saveUser}
    >
      {loading && (
        <div className="installation-detail-state">
          <div className="installation-detail-spinner" aria-hidden />
          <p>{t("installation_loading")}</p>
        </div>
      )}
      {!loading && (
        <div className="installation-subpage-card installation-subpage-card-flush">
          <InstallationVisualizationPanel
            routeCameraId={id}
            cycleEntries={cycleEntries}
          />
        </div>
      )}
    </InstallationSubpageLayout>
  );
};

export default AppInstallationVisualization;
